module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/LeCreuset-5b24fc533733ec6886cc4182e48b5fb5.webp";